import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import { Spinner } from 'shared/ui/spinner';

import { ButtonContentStyle, ButtonLoaderStyle } from './styled';

type LoadingButtonProps = {
  errorField?: string;
  errorFieldSecondary?: string;
  isLoading?: boolean;
} & ButtonProps;

export const LoadingButton = ({
  isLoading,
  disabled,
  variant = 'contained',
  color = 'primary',
  startIcon,
  children,
  ...props
}: LoadingButtonProps) => {
  return (
    <Button
      fullWidth
      variant={variant}
      color={color}
      disabled={disabled || isLoading}
      {...props}
      startIcon={!isLoading && startIcon}
      sx={{
        ...props?.sx,
      }}
    >
      <ButtonContentStyle
        // @ts-expect-error: types
        component="span"
        textAlign="center"
        variant="inherit"
        color="inherit"
        fontFamily="inherit"
        $disabled={disabled}
        $hidden={isLoading}
      >
        {children}
      </ButtonContentStyle>
      {isLoading && (
        <ButtonLoaderStyle>
          <Spinner size={24} />
        </ButtonLoaderStyle>
      )}
    </Button>
  );
};
